// extracted by mini-css-extract-plugin
export default {"btnpwd":"_1d11c2af2a"};